import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FDB813" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink taget="_blank" href="https://www.facebook.com/Crescent-Harbour-House-Restaurant-629212510569684/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Blue Coast Japanese Seafood Cuisine Restaurant Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/bluecoast_cuisine_yvr/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Blue Coast Japanese Seafood Cuisine Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FDB813" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink taget="_blank" href="https://www.facebook.com/Crescent-Harbour-House-Restaurant-629212510569684/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Blue Coast Japanese Seafood Cuisine Restaurant Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/bluecoast_cuisine_yvr/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Blue Coast Japanese Seafood Cuisine Restaurant Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
